import React from 'react';
import Tracker from 'tracker';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
/* eslint no-unused-vars: 0 */
import css from 'components/image_manager.scss';

/* Max file size for an individual attachment is 3MB */
const MAX_FILE_SIZE = 3145728;
/* Make sure each vendor can only have a max of 10 photos */
const MAX_FILE_COUNT = 10;

const DragHandle = SortableHandle(({ image }) => {
    if (image.id) {
        return <div className="sortable-handle" style={{ backgroundImage: `url(${image.small})` }} />;
    }

    return <div className="sortable-handle" style={{ backgroundImage: `url(${image.data_uri})` }} />;
});

const SortableImage = SortableElement((props) => {
    return (
        <div className="sortable-thumbnail">
            <DragHandle image={props.image} />
            <div className="delete-link">
                <a href="#" className="btn btn-primary" onClick={(e) => props.onRemoveClick(e, props.imageIndex)}>Delete</a>
            </div>
        </div>
    );
});

const SortableGallery = SortableContainer((props) => {
    return (
        <div className="images">
            {props.images.map((image, index) => {
                if (image.deleted) {
                    return null;
                }

                return <SortableImage
                    key={`item-${image.id || image.key}`}
                    imageIndex={index}
                    index={index}
                    image={image}
                    onRemoveClick={props.handleRemoveImageClick}
                />;
            })}

            <div className="add-images sortable-thumbnail" onClick={props.handleAddImagesClick}>
                <span>Add Photos</span>
            </div>
        </div>
    );
});

export default class extends React.Component {
    static propTypes = {
        onChange: React.PropTypes.func.isRequired,
        title: React.PropTypes.string,
        vendorImages: React.PropTypes.array,
    };

    static defaultProps = {
        title: 'Photos',
        vendorImages: [],
    };

    constructor(props) {
        super(props);

        this.tracker = new Tracker();

        this.state = {
            error: '',
            images: props.vendorImages,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.vendorImages !== nextProps.vendorImages) {
            this.setState({
                images: nextProps.vendorImages,
            });
        }
    }

    handleSortEnd = ({ oldIndex, newIndex }) => {
        this.setState({
            images: arrayMove(this.state.images, oldIndex, newIndex),
        }, () => {
            this.props.onChange(this.state.images);
        });
    };

    handleAddImagesClick = () => {
        this.refs.images.click();
    };

    handleRemoveImageClick = (e, index) => {
        e.preventDefault();

        const images = this.state.images;
        if (images[index].id) {
            images[index].deleted = true;
        } else {
            delete images[index];
        }

        this.setState({ images: images }, () => {
            this.props.onChange(this.state.images);
        });
    };

    onChange = (e) => {
        let processedCount = 0;
        const filesWithErrors = [];
        const images = this.state.images;
        const uploadedCount = e.target.files.length;

        if ((uploadedCount + images.length) > MAX_FILE_COUNT) {
            this.setState({ error: 'You can only have up to 30 photos on this profile.' });
            return;
        }

        const onLoad = (file, upload) => {
            processedCount += 1;
            images.push({
                key: Date.now() + Math.random(),
                data_uri: upload.target.result,
                filename: file.name,
                filetype: file.type,
            });
        };

        const onLoadStart = (reader, file, upload) => {
            if (upload.lengthComputable && upload.total > MAX_FILE_SIZE) {
                processedCount += 1;
                filesWithErrors.push(file.name);
                reader.abort();
            }
        };

        const onLoadEnd = () => {
            if (processedCount !== uploadedCount) {
                return;
            }

            let errorMessage = '';
            if (filesWithErrors.length > 1) {
                errorMessage = 'Files ' + filesWithErrors.join(', ') + ' must be less than 3MB in size.';
            } else if (filesWithErrors.length === 1) {
                errorMessage = 'File ' + filesWithErrors[0] + ' must be less than 3MB in size.';
            }

            this.setState({ images: images, error: errorMessage }, () => {
                this.props.onChange(this.state.images);
            });
        };

        for (let i = 0; i < e.target.files.length; i += 1) {
            const file = e.target.files[i];
            const reader = new FileReader();

            reader.onload = onLoad.bind(this, file);
            reader.onloadstart = onLoadStart.bind(this, reader, file);
            reader.onloadend = onLoadEnd.bind(this);
            reader.readAsDataURL(file);
        }
    };

    render() {
        return (
            <div className="image-gallery">
                <h2>{this.props.title}</h2>
                <h3>Optional</h3>

                {this.state.error && <div className="alert alert-danger">
                    {this.state.error}
                </div>}

                <SortableGallery
                    images={this.state.images}
                    onSortEnd={this.handleSortEnd}
                    useWindowAsScrollContainer={true}
                    hideSortableGhost={false}
                    useDragHandle={true}
                    handleAddImagesClick={this.handleAddImagesClick}
                    handleRemoveImageClick={this.handleRemoveImageClick}
                    axis="xy"
                />

                <input type="file" ref="images" onChange={this.onChange} multiple={true} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/vendors/ImageManager.jsx